// Centralized constants for the retro terminal portfolio client

export function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export const CONFIG = {
    LOCALHOST: 'localhost',
    LOOPBACK: '127.0.0.1',
    FILE_PROTOCOL: 'file:',
    DEFAULT_PORT: '8080',
    LOCAL_API_BASE: 'http://localhost:8080',
    EMPTY: '',
    SPACE: ' ',
    HTTPS_PROTOCOL_PREFIX: 'https://',
    DB_PORT_DEFAULT: '5432',
    NEWLINE: '\n',
    MARKDOWN_H1_PREFIX: '# ',
    MARKDOWN_H2_PREFIX: '## ',
    MARKDOWN_H3_PREFIX: '### ',
    MARKDOWN_BULLET_STAR: '* ',
    MARKDOWN_BULLET_DASH: '- ',
    MARKDOWN_H1_INCLUSION: '##',
    EXIT: 'exit',
    CANCEL: 'cancel',
    SUCCESS: 'success',
    DATA_THEME_ATTR: 'data-theme',
    TRUE: 'true',
    FALSE: 'false',
    KEY_ENTER: 'Enter',
    KEY_UP: 'ArrowUp',
    KEY_DOWN: 'ArrowDown',
    KEY_TAB: 'Tab'
};

export const DOM_EVENTS = {
    DOM_CONTENT_LOADED: 'DOMContentLoaded',
    CLICK: 'click',
    INPUT: 'input',
    KEYDOWN: 'keydown'
};

export const API_ENDPOINTS = {
    SYSINFO: '/api/sysinfo',
    PROFILE: '/api/profile',
    SKILLS: '/api/skills',
    PROJECTS: '/api/projects',
    EXPERIENCE: '/api/experience',
    CONTACT: '/api/contact',
    BLOGS: '/api/blogs',
    BLOG_DETAIL: (slug) => `/api/blogs/${slug}`
};

export const API_METHODS = {
    GET: 'GET',
    POST: 'POST'
};

export const CONTENT_TYPES = {
    JSON: 'application/json'
};

export const CSS_CLASSES = {
    ACCENT: 'text-accent',
    TITLE: 'text-title',
    COMMENT: 'text-comment',
    ERROR: 'text-error',
    WARNING: 'text-warning',
    SUCCESS: 'text-success',
    CRT_EFFECT: 'crt-effect',
    SKILLS_GRID: 'skills-grid',
    SKILLS_CATEGORY: 'skills-category',
    SKILLS_LIST: 'skills-list',
    PROJECT_CARD: 'project-card',
    PROJECT_TITLE: 'project-title',
    PROJECT_DETAILS: 'project-details',
    PROJECT_DESC: 'project-desc',
    PROJECT_TECH: 'project-tech',
    TECH_TAG: 'tech-tag',
    EXP_CARD: 'exp-card',
    EXP_TITLE: 'exp-title',
    EXP_DETAILS: 'exp-details',
    EXP_BULLETS: 'exp-bullets',
    SYS_GRID: 'sys-grid',
    SYS_LABEL: 'sys-label',
    SYS_VAL: 'sys-val',
    PROMPT_PREFIX: 'prompt-prefix',
    PROMPT_USER: 'prompt-user',
    PATH_PREFIX: 'path-prefix',
    BLINKING_CURSOR: 'blinking-cursor',
    ASCII_BANNER: 'ascii-banner',
    BANNER_SYSTEMS: 'banner-systems',
    JSON_KEY: 'json-key',
    JSON_STRING: 'json-string',
    JSON_NUMBER: 'json-number',
    JSON_BOOLEAN: 'json-boolean',
    JSON_NULL: 'json-null',
    MEDIA_IMG: 'terminal-media-img',
    MEDIA_VIDEO_WRAPPER: 'terminal-media-video-wrapper',
    MEDIA_VIDEO: 'terminal-media-video',
    BLOG_H2: 'blog-h2',
    BLOG_H3: 'blog-h3',
    BLOG_CODE_BLOCK: 'blog-code-block',
    BLOG_INLINE_CODE: 'blog-inline-code'
};

export const DOM_SELECTORS = {
    TERMINAL_BODY: 'terminal-body',
    TERMINAL_OUTPUT: 'terminal-output',
    TERMINAL_INPUT: 'terminal-input',
    TERMINAL_TEXT: 'terminal-text',
    CURSOR: '.terminal-cursor',
    TOGGLE_CRT: 'toggle-crt',
    THEME_DOT: '.theme-dot',
    THEME_SELECTOR_GROUP: '.theme-selector-group',
    PATH_PREFIX: '.path-prefix',
    PROMPT_PREFIX: '.prompt-prefix',
    INPUT_LINE_PROMPT_PREFIX: '.input-line .prompt-prefix',
    INPUT_LINE_PATH_PREFIX: '.input-line .path-prefix',
    BANNER_SYSTEMS: '.banner-systems',
    LOADING_SCREEN: 'loading-screen',
    LOADING_TITLE: 'loading-title',
    LOADING_PROGRESS: 'loading-progress',
    LOADING_STATUS: 'loading-status'
};

export const THEMES = {
    DRACULA: 'dracula',
    MATRIX: 'matrix',
    AMBER: 'amber',
    CYBERPUNK: 'cyberpunk',
    COBALT: 'cobalt'
};

export const THEME_LIST = [THEMES.DRACULA, THEMES.MATRIX, THEMES.AMBER, THEMES.CYBERPUNK, THEMES.COBALT];

export const LOCAL_STORAGE_KEYS = {
    THEME: 'theme',
    CRT_EFFECT: 'crt-effect'
};

export const COMMANDS = {
    HELP: 'help',
    ABOUT: 'about',
    SKILLS: 'skills',
    PROJECTS: 'projects',
    EXPERIENCE: 'experience',
    SYSINFO: 'sysinfo',
    LS: 'ls',
    CD: 'cd',
    CAT: 'cat',
    CURL: 'curl',
    THEME: 'theme',
    CLEAR: 'clear',
    CONTACT: 'contact',
    BLOG: 'blog',
    WHOAMI: 'whoami'
};

export const COMMAND_LIST = [
    COMMANDS.HELP,
    COMMANDS.ABOUT,
    COMMANDS.SKILLS,
    COMMANDS.PROJECTS,
    COMMANDS.EXPERIENCE,
    COMMANDS.SYSINFO,
    COMMANDS.LS,
    COMMANDS.CD,
    COMMANDS.CAT,
    COMMANDS.CURL,
    COMMANDS.THEME,
    COMMANDS.CLEAR,
    COMMANDS.CONTACT,
    COMMANDS.BLOG,
    COMMANDS.WHOAMI
];

export const BLOG_SUBCOMMANDS = {
    LIST: 'list',
    VIEW: 'view',
    HELP: 'help'
};

export const BLOG_SUBCOMMANDS_LIST = [
    BLOG_SUBCOMMANDS.LIST,
    BLOG_SUBCOMMANDS.VIEW,
    BLOG_SUBCOMMANDS.HELP
];

export const FS_ENTRY_TYPES = {
    DIR: 'dir',
    FILE: 'file'
};

export const PATHS = {
    ROOT: '/',
    HOME: '~',
    PARENT: '..'
};

export const WIZARD_STEPS = {
    NAME: 0,
    EMAIL: 1,
    MESSAGE: 2
};

export const REGEX_PATTERNS = {
    EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    JSON_COLORIZER: /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
    MARKDOWN_H1: /^#\s+(?!.*##)/,
    MARKDOWN_H3: /^###\s+/,
    MARKDOWN_H2: /^##\s+/,
    MARKDOWN_BULLET: /^[*-]\s+/,
    MARKDOWN_CODE_JAVA: /```java([\s\S]*?)```/g,
    MARKDOWN_CODE_BLOCK: /```([\s\S]*?)```/g,
    MARKDOWN_INLINE_CODE: /`([^`]+)`/g,
    MARKDOWN_BOLD: /\*\*([^*]+)\*\*/g,
    MARKDOWN_ITALIC: /\*([^*]+)\*/g,
    MARKDOWN_LINK: /\[([^\]]+)\]\(([^)]+)\)/g,
    NEWLINE: /\n/g
};

export const FALLBACK_BLOG_SLUGS = ['java-25-concurrency', 'kafka-event-pipeline'];

export const MESSAGES = {
    LOADING_DIAGNOSTICS: 'Systems: Loading platform diagnostics...',
    DEFAULT_SYSTEMS_INFO: 'Systems: Spring Boot 4.0.6 | Java 25',
    SYSTEMS_INFO: (sbVer, javaVer) => `Systems: Spring Boot ${sbVer} | Java ${javaVer}`,
    WELCOME_TITLE: 'Welcome to my personal workspace console.',
    WELCOME_HELP_HINT: 'Type <span class="text-accent">help</span> to view all available commands and begin exploration.\n',
    API_FETCHING: 'Fetching data from API...',
    API_CONNECTION_ERROR: (msg) => `Network connection error calling REST API: ${msg}`,
    API_PORT_WARNING: 'Make sure the Spring Boot service is running locally on port 8080.',
    WIZARD_START: '--- Starting Contact Mailer Wizard ---\nType "exit" or "cancel" at any prompt to abort.\n',
    WIZARD_NAME_EMPTY: 'Name cannot be empty. Please enter your name: ',
    WIZARD_NAME_PROMPT: 'contact (name) > ',
    WIZARD_NAME_ECHO: (name) => `contact (name) > ${escapeHtml(name)}`,
    WIZARD_EMAIL_PROMPT: 'contact (email) > ',
    WIZARD_EMAIL_INVALID: 'Invalid email format. Please enter a valid email address: ',
    WIZARD_EMAIL_ECHO: (email) => `contact (email) > ${escapeHtml(email)}`,
    WIZARD_MESSAGE_PROMPT: 'contact (message) > ',
    WIZARD_MESSAGE_EMPTY: 'Message cannot be empty. Please enter message: ',
    WIZARD_MESSAGE_ECHO: (msg) => `contact (message) > ${escapeHtml(msg)}`,
    WIZARD_CANCELLED: '\nContact wizard cancelled.',
    CMD_THEME_USAGE: `Usage: theme [theme-name]`,
    CMD_THEME_SWITCHED: (theme) => `Theme switched to: ${escapeHtml(theme)}`,
    CMD_THEME_INVALID: (theme, themes) => `Invalid theme: ${escapeHtml(theme)}. Choose from: ${escapeHtml(themes.join(', '))}`,
    CMD_LS_EMPTY: 'Total files: 0',
    CMD_CAT_USAGE: 'Usage: cat [filename]',
    CMD_CAT_DIR: (name) => `cat: ${escapeHtml(name)}: Is a directory`,
    CMD_CAT_NOT_FOUND: (name) => `cat: ${escapeHtml(name)}: No such file or directory`,
    CMD_CD_NOT_FOUND: (name) => `cd: no such directory: ${escapeHtml(name)}`,
    CMD_CURL_USAGE: 'Usage: curl [-X GET] [/api/endpoint]\nTry: <span class="text-comment">curl /api/sysinfo</span> or <span class="text-comment">curl /api/projects</span>',
    CMD_CURL_INVALID: 'Error: Invalid endpoint. Paths must begin with "/api/".',
    CMD_BLOG_HELP: `
<div class="help-container">
  <div class="help-header">Blog Engine Commands:</div>
  <div class="help-row">
    <span class="help-cmd">blog list</span>
    <span class="help-sep">-</span>
    <span class="help-desc">List all published blog articles</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">blog view [slug]</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Read a post and view media (images & video embeds)</span>
  </div>
  <div class="help-footer">Example: <span class="text-comment">blog view java-25-concurrency</span></div>
</div>
`,
    CMD_BLOG_EMPTY: '\nNo blog posts found.',
    CMD_BLOG_LIST_TITLE: '\nAvailable Articles:',
    CMD_BLOG_VIEW_USAGE: 'Usage: blog view [slug]',
    CMD_BLOG_VIEW_NOT_FOUND: (slug) => `Blog post with slug &quot;${escapeHtml(slug)}&quot; not found.`,
    CMD_BLOG_INVALID_SUB: (sub) => `Unknown blog subcommand: &quot;${escapeHtml(sub)}&quot;. Type &quot;blog help&quot; for details.`,
    CMD_NOT_FOUND: (cmd, suggestions) => {
        let msg = "bash: command not found: " + escapeHtml(cmd) + ".";
        if (suggestions && suggestions.length > 0) {
            msg += " Did you mean: <span class=\"text-accent\">" + escapeHtml(suggestions.join(', ')) + "</span>?";
        } else {
            msg += " Type 'help' to see list of valid commands.";
        }
        return msg;
    },

    ASCII_LOGO: `
____   ____.__ __                       _____       .___.__                .__   
\\\\   \\\\ /   /|__|  | _______    ______   /  _  \\\\    __| _/|__|_  _  _______  |  |  
 \\\\   Y   / |  |  |/ /\\\\__  \\\\  /  ___/  /  /_\\\\  \\\\  / __ | |  \\\\ \\\\/ \\\\/ /\\\\__  \\\\ |  |  
  \\\\     /  |  |    <  / __ \\\\_\\\\___ \\\\  /    |    \\\\/ /_/ | |  |\\\\     /  / __ \\\\|  |__
   \\\\___/   |__|__|_ \\\\/(____  /____  > \\\\____|__  /\\\\____ | |__| \\\\/\\\\_/  (____  /____/
                   \\\\/     \\\\/     \\\\/          \\\\/      \\\\/                  \\\\/      
    `,
    ASCII_LOGO_PART1: `____   ____.__ __                       
\\\\   \\\\ /   /|__|  | _______    ______   
 \\\\   Y   / |  |  |/ /\\\\__  \\\\  /  ___/  
  \\\\     /  |  |    <  / __ \\\\_\\\\___ \\\\  
   \\\\___/   |__|__|_ \\\\/(____  /____  > 
                   \\\\/     \\\\/     \\\\/`,
    ASCII_LOGO_PART2: ` _____       .___.__                .__   
/  _  \\\\    __| _/|__|_  _  _______  |  |  
/  /_\\\\  \\\\  / __ | |  \\\\ \\\\/ \\\\/ /\\\\__  \\\\ |  |  
/    |    \\\\/ /_/ | |  |\\     /  / __ \\\\|  |__
\\\\____|__  /\\\\____ | |__| \\\\/\\\\_/  (____  /____/
        \\\\/      \\\\/                  \\\\/`,
    HELP_TEXT: `
<div class="help-container">
  <div class="help-header">Available commands:</div>
  <div class="help-row">
    <span class="help-cmd">about</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Print overview profile text</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">skills</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Print structured technical skills</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">projects</span>
    <span class="help-sep">-</span>
    <span class="help-desc">List software engineering projects</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">experience</span>
    <span class="help-sep">-</span>
    <span class="help-desc">List career/work history timeline</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">sysinfo</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Query server JVM & platform diagnostics</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">contact</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Send a message to Vikas (interactive wizard)</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">blog</span>
    <span class="help-sep">-</span>
    <span class="help-desc">List articles & view dynamic media posts</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">curl</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Make GET calls (e.g. <span class="text-comment">curl /api/projects</span>)</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">ls</span>
    <span class="help-sep">-</span>
    <span class="help-desc">List simulated filesystem files</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">cd [dir]</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Change simulated directories</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">cat [file]</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Display contents of simulated files</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">theme [name]</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Change console style theme (dracula, matrix, amber, cyberpunk, cobalt)</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">whoami</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Print current session user</span>
  </div>
  <div class="help-row">
    <span class="help-cmd">clear</span>
    <span class="help-sep">-</span>
    <span class="help-desc">Clear the screen</span>
  </div>
</div>
`
};

export const VIRTUAL_FS_DATA = {
    ABOUT_NAME: 'about.md',
    ABOUT_CONTENT: 'Vikas Adiwal - Senior Backend & Distributed Systems Engineer\n=======================================================\nExpert in building concurrent, scalable, and resilient distributed applications.\nSpecializes in Java/Spring systems, event ingestion architectures, and cloud migrations.\n\nType "about" to query the live API for complete profile info.',
    SKILLS_NAME: 'skills.json',
    SKILLS_CONTENT: '{\n  "languages": ["Java 25", "Kotlin", "Go", "SQL", "Bash"],\n  "frameworks": ["Spring Boot 4.0", "gRPC", "WebFlux", "Hibernate"],\n  "databases": ["PostgreSQL", "Redis", "Cassandra", "MongoDB"],\n  "messaging": ["Kafka", "RabbitMQ"]\n}',
    CONTACT_NAME: 'contact.sh',
    CONTACT_CONTENT: '#!/bin/bash\necho "Running contact wizard..."\necho "Type the command [contact] directly in the terminal to launch the interactive message sender!"',
    PROJECTS_DIR_NAME: 'projects',
    SCHEDULER_NAME: 'scheduler.txt',
    SCHEDULER_CONTENT: 'Project: Distributed Task Scheduler\nStack: Go, Redis, gRPC, Docker\nDescription: A highly reliable clustered cron scheduler implementing partition tolerance and lock mechanisms.',
    ORDER_ENGINE_NAME: 'order_engine.txt',
    ORDER_ENGINE_CONTENT: 'Project: Event-Driven Order Processing Engine\nStack: Java 25, Spring Boot 4, Apache Kafka, PostgreSQL, Kubernetes\nDescription: Core order orchestration engine scaling to 12,000 req/sec with strong transaction isolation.',
    CACHE_PROXY_NAME: 'cache_proxy.txt',
    CACHE_PROXY_CONTENT: 'Project: High-Performance API Cache Gateway\nStack: Java 25, Spring WebFlux, Netty, Redis, Docker\nDescription: Reactive reverse-proxy cache service utilizing token bucket algorithms for rate limiting.'
};

export const HTML_TEMPLATES = {
    H3: (content) => `<h3 class="blog-h3">${content}</h3>`,
    H2: (content) => `<h2 class="blog-h2">${content}</h2>`,
    BULLET: (content) => `• ${content}`,
    CODE_BLOCK: (content) => `<pre class="blog-code-block"><code>${content}</code></pre>`,
    INLINE_CODE: (content) => `<code class="blog-inline-code">${content}</code>`,
    BOLD: (content) => `<strong>${content}</strong>`,
    ITALIC: (content) => `<em>${content}</em>`,
    LINK: (text, url) => {
        const sanitizedUrl = (url.trim().toLowerCase().startsWith('javascript:') || url.trim().toLowerCase().startsWith('data:')) ? '#' : url;
        return `<a href="${sanitizedUrl}" target="_blank" class="text-accent">${text}</a>`;
    },
    BR: '<br>',
    SKILLS_GRID_CONTAINER: (content) => `<div class="skills-grid">${content}</div>`,
    SKILLS_GRID_CATEGORY: (category, items) => `
        <div class="skills-category">
            <h3>${escapeHtml(category)}</h3>
            <ul class="skills-list">
                ${items.map(item => `<li>${escapeHtml(item)}</li>`).join('')}
            </ul>
        </div>
    `,
    PROJECT_CARD: (name, role, githubUrl, description, tagsHtml) => `
        <div class="project-card">
            <div class="project-title">${escapeHtml(name)}</div>
            <div class="project-details">Role: ${escapeHtml(role)} | <a href="${escapeHtml(githubUrl)}" target="_blank" class="text-accent">GitHub Link</a></div>
            <div class="project-desc">${escapeHtml(description)}</div>
            <div class="project-tech">${tagsHtml}</div>
        </div>
    `,
    TECH_TAG: (tag) => `<span class="tech-tag">${escapeHtml(tag)}</span>`,
    EXP_CARD: (role, company, duration, bulletsHtml) => `
        <div class="exp-card">
            <div class="exp-title">${escapeHtml(role)} @ ${escapeHtml(company)}</div>
            <div class="exp-details">${escapeHtml(duration)}</div>
            <ul class="exp-bullets">
                ${bulletsHtml}
            </ul>
        </div>
    `,
    SYS_GRID: (javaVersion, springBootVersion, uptimeSeconds, totalMemoryMb, freeMemoryMb, availableProcessors, osName, osArch) => `
        <div class="sys-grid">
            <span class="sys-label">JVM Java Version:</span> <span class="sys-val">${escapeHtml(javaVersion)}</span>
            <span class="sys-label">Spring Boot:</span> <span class="sys-val">${escapeHtml(springBootVersion)}</span>
            <span class="sys-label">Application Uptime:</span> <span class="sys-val">${escapeHtml(uptimeSeconds)} seconds</span>
            <span class="sys-label">Total JVM Memory:</span> <span class="sys-val">${escapeHtml(totalMemoryMb)} MB</span>
            <span class="sys-label">Free JVM Memory:</span> <span class="sys-val">${escapeHtml(freeMemoryMb)} MB</span>
            <span class="sys-label">CPU Cores Available:</span> <span class="sys-val">${escapeHtml(availableProcessors)} Cores</span>
            <span class="sys-label">OS Name:</span> <span class="sys-val">${escapeHtml(osName)}</span>
            <span class="sys-label">OS Architecture:</span> <span class="sys-val">${escapeHtml(osArch)}</span>
        </div>
    `,
    BLOG_IMAGE: (imageUrl, title) => `<div class="terminal-media-img"><img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(title)}" onerror="this.parentElement.remove()"></div>`,
    BLOG_VIDEO: (youtubeVideoId) => `
        <div class="terminal-media-video-wrapper">
            <p class="text-comment">// Video Walkthrough:</p>
            <div class="terminal-media-video">
                <iframe src="https://www.youtube.com/embed/${escapeHtml(youtubeVideoId)}" 
                        title="YouTube video player" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerpolicy="strict-origin-when-cross-origin" 
                        allowfullscreen>
                </iframe>
            </div>
        </div>
    `,
    PROMPT_ECHO: (promptPath, rawInput) => `<span class="prompt-prefix"><span class="prompt-user">guest@adiwal.com</span>:<span class="path-prefix">${escapeHtml(promptPath)}</span>$</span> ${escapeHtml(rawInput)}`,
    PROMPT_HTML: (promptPath) => `<span class="prompt-user">guest@adiwal.com</span>:<span class="path-prefix">${escapeHtml(promptPath)}</span>$`,
    LS_DIR_ENTRY: (name) => `<span class="text-accent">${escapeHtml(name)}/</span>`,
    LS_EXEC_ENTRY: (name) => `<span class="text-success">${escapeHtml(name)}*</span>`
};

export const METADATA = {
    TITLE: 'Vikas Adiwal | Backend Engineer Terminal',
    WINDOW_TITLE_EMAIL: 'vikas@adiwal.com',
    WINDOW_TITLE_SHELL: '~ (bash)',
    CRT_BTN_TEXT: 'CRT',
    CRT_BTN_TITLE: 'Toggle CRT Scanlines Effect',
    FOOTER_SHORTCUTS: [
        '[Tab] Autocomplete',
        '[↑/↓] Command History',
        "Type 'help' to start"
    ],
    THEME_DOTS: [
        { theme: 'dracula', title: 'Dracula Theme', class: 'dot-dracula' },
        { theme: 'matrix', title: 'Matrix green', class: 'dot-matrix' },
        { theme: 'amber', title: 'Amber Monochrome', class: 'dot-amber' },
        { theme: 'cyberpunk', title: 'Cyberpunk', class: 'dot-cyberpunk' },
        { theme: 'cobalt', title: 'Cobalt Blue', class: 'dot-cobalt' }
    ],
    LOADING_TITLE_PREFIX: 'BOOTING SYSTEM',
    LOADING_STATUS_CONNECTING: 'Establishing uplink connection...',
    LOADING_STATUS_DIAGNOSTICS: 'Loading platform diagnostics...',
    LOADING_STATUS_COMPLETED: 'Core system loaded successfully.'
};
